import * as React from "react";

// style, design
import CancelParkingContractForm from "../../components/Forms/ParkingContract/CancelForm/FlowForm";

export default () => {
  return <CancelParkingContractForm />;
};
